import React, { useState } from 'react';
import './Button.scss';

interface IconButtonProps {
    text?: string,
    onClick?: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => void;
}

const Button: React.FC<IconButtonProps> = (props: IconButtonProps) => {

    const [isCopied, setIsCopied] = useState(false);

    const onCopyText = () => {
        copyToClipboard(props.text);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
    };

    const copyToClipboard = (str) => {
        const el = document.createElement("textarea")
        el.value = str
        el.setAttribute("readonly", "")
        el.style.position = "absolute"
        el.style.left = "-9999px"
        document.body.appendChild(el)
        el.select()
        document.execCommand("copy")
        document.body.removeChild(el)
    }

    return (
        <button onClick={props.onClick ?? onCopyText}
            style={{
                position: "absolute",
                top: 0,
                right: 0,
                border: "none",
                boxShadow: "none",
                textDecoration: "none",
                margin: "8px",
                padding: "8px 12px",
                background: "transparent",
                color: "white",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "14px",
                fontFamily: "sans-serif",
                lineHeight: "1",
            }}
        >
            <span>
                {isCopied ? (
                    'Copiado!'
                ) : (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 0 24 24"
                        width="24px"
                        fill="#FFFFFF"
                        className="copyIcon"
                    >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                    </svg>
                )}
            </span>
        </button>
    );
};

export default Button;
